import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import NavMenu from './NavMenu';
import HeaderLinks from './HeaderLinks';
import Referrer from './Referrer';
import css from '../../../css/css-variables.json';
import SwitchProfile from '../containers/SwitchProfile';
import { ENABLE_ORG_MANAGEMENT } from '../constants';

const MobileNavWrapper = styled.div`
  background-color: ${css.colors.AccentLight};
  border-bottom-style: solid;
  border-bottom-color: #e0e0e0;
  border-bottom-width: 2px;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-bottom: 0.5em;
`;

const MobileNav = styled.nav`
  background-color: white;
  border: 1px solid #e1e1e1;
  overflow: hidden;
  padding-left: 0.7em;
  padding-right: 0.7em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
`;

const Span = styled.span`
  overflow: hidden;
`;

const LinksWrapper = styled.div`
  border-bottom-style: solid;
  border-bottom-color: #e0e0e0;
  border-bottom-width: 2px;
  text-align: right;
  padding-bottom: 0.125em;
`;

const MobileNavMenu = props => {
  const { location, breakPoints, isLoggedIn, onLogOut, isOpen, navToggle, referredBy, customer } = props;

  const attrs = {
    props: { path: location.pathname, breakPoints, isLoggedIn, onLogOut, isOpen, navToggle, isMobile: true, customer }
  };
  const styles = {
    aCommon: ['l0_Py(0em)', 'l1_Py(0em)', 'l0_Px(0em)', 'l1_Px(1.071em)', 'l3_Px(2.143em)', 'Td(n):h'],
    liCommon: ['l0_Bd(n)'],
    liActive: ['Bd(n)'],
    liInactive: ['Bd(n)', 'l0_Bdtw(0px)'],
    firstChildStyles: { liCommon: ['l0_Pt(0em)', 'l0_Bd(n)', ''], aCommon: ['l0_Px(0em)', 'l0_Pt(0.556em)'] },
    lastChildStyles: { liCommon: ['l0_Bd(n)', 'Mb(0.111em)'], aCommon: ['l0_Py(0em)', 'l0_Px(0em)', 'Td(n):h'] },
    menuTop: ['Mt(0px)']
  };
  const refStyles = { a: [] };

  return (
    <MobileNavWrapper>
      <MobileNav>
        <LinksWrapper>
          <Span><HeaderLinks {...attrs.props} /></Span>
        </LinksWrapper>
        {referredBy && <Referrer styles={refStyles} referredBy={referredBy} />}
        <NavMenu isMobile={true} isLoggedIn={isLoggedIn} location={location} styles={styles} navToggle={navToggle} isOpen={isOpen} />
        {ENABLE_ORG_MANAGEMENT && <SwitchProfile navToggle={navToggle} />}
      </MobileNav>
    </MobileNavWrapper>
  );
};

const { object, bool, func, string } = PropTypes;

MobileNavMenu.propTypes = {
  location: object.isRequired,
  isOpen: bool.isRequired,
  navToggle: func,
  referredBy: string,
  isLoggedIn: bool,
  breakPoints: object,
  onLogOut: func,
  customer: object
};

export default MobileNavMenu;
